import Crud from '../views/Modelo/Crud'
import Entity from '../views/Modelo/Add'

let routes = {
    path: '/modelos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/modelos/add',
            name: 'NewModelo',
            component: Entity
        },
        {
            path: '/modelos/edit/:id?',
            name: 'EditModelo',
            component: Entity
        },
        {
            path: '/modelos',
            name: 'list-modelos',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Modelos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
